var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S6 13.17 6 14s.67 1.5 1.5 1.5zm.5-5V6h-1v4.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S8.83 10.5 8 10.5zm4.5 5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm.5-5V6h-1v4.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm4.5 2c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM15 3H9v1.5h6V3zm0 16.5H9V21h6v-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorsIcon);
export default __webpack_public_path__ + "static/media/SensorsIcon.ecedc12a80200e51570957f17157d3a2.svg";
export { ForwardRef as ReactComponent };